import type { Xinglet } from '@xing-com/crate-xinglet';

import { Container } from './container';

export default class SerpsContainer implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <Container />;
  }
}
